// src/redux/slices/iphcPractitionerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../constants/config";

// Fetch IPHC practitioner by email
export const fetchClinicPractitionerByEmail = createAsyncThunk(
  "clinicPractitioner/fetchByEmail",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/iphc-practitioner-info?email=${email}`
      );
      return response.data.iphcPractitioner || null;
    } catch (error) {
      console.error("Error fetching IPHC practitioner by email:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const iphcPractitionerSlice = createSlice({
  name: "iphcPractitioner",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearPractitioner: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClinicPractitionerByEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClinicPractitionerByEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchClinicPractitionerByEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPractitioner } = iphcPractitionerSlice.actions;

export default iphcPractitionerSlice.reducer;
